export const GET_RESERVATIONS = 'GET_DASHBOARD_RESERVATIONS'
export const GET_MORE_RESERVATIONS = 'GET_MORE_DASHBOARD_RESERVATIONS'
export const SET_RESERVATIONS = 'SET_DASHBOARD_RESERVATIONS'
export const SET_STATUS_FILTER = 'SET_DASHBOARD_STATUS_FILTER'

export const OPEN_RESERVATION_DETAILS = 'OPEN_RESERVATION_DETAILS'
export const CLOSE_RESERVATION_DETAILS = 'CLOSE_RESERVATION_DETAILS'

export const GET_RESERVATION_CANCEL_AMEND_POLICY = 'GET_RESERVATION_CANCEL_AMEND_POLICY'
export const SET_CANCEL_RESERVATION_VALUES = 'SET_CANCEL_RESERVATION_VALUES'
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION'
export const CONFIRM_CANCEL_RESERVATION = 'CONFIRM_CANCEL_RESERVATION'
export const CLOSE_CANCELLATION_MODAL = 'CLOSE_CANCELLATION_MODAL'
export const CANCEL_RESERVATION_FAILED = 'CANCEL_RESERVATION_FAILED'
export const RESET_CANCEL_RESERVATION_FAILED_ERROR = 'RESET_CANCEL_RESERVATION_FAILED_ERROR'
export const CHANGE_VEHICLE = 'CHANGE_VEHICLE'
export const DOWNLOAD_RECEIPT = 'DOWNLOAD_RECEIPT'
export const UPDATE_ENTITY = 'UPDATE_ENTITY'

export const CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD'
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'
